<template>
  <div>

    <a-list :grid="{ gutter: 16, xs: 3, sm: 2, md: 4, lg: 4, xl: 6, xxl: 3 }" :dataSource="folders">
        <a-list-item slot="renderItem" slot-scope="item">

        <a-card hoverable :bodyStyle="{padding:0, textAlign:'center'}"  @click="showDrawer(item)"  :headStyle="{border:'none'}" :bordered="false"  >
            <img v-if="item.childrens.length" slot="extra" src="../../../../assets/icons/folder_2@2x.svg" class="img-fluid" alt="">
            <img v-else slot="extra" src="../../../../assets/icons/folder@2x.svg" class="img-fluid" alt="">
            {{item.name}}
        </a-card>
        </a-list-item>
    </a-list>

    <a-drawer  :title="titleFolder" placement="right" :closable="false" @close="onClose" :visible="folderShow" width=740>
        <folderDetails :folder.sync="folder"/>
    </a-drawer>

  </div>
</template>

<script>

import folderDetails from './folderDetails'

export default {
  name: 'FileManager',
  components: {
    folderDetails,
  },
  props: ['folders'],
  data() {
    return {
      folder: {},
      folderShow: false,
    }
  },
  computed: {
    titleFolder: function() {
      return '' + (this.folder ? this.folder.name : 'N/D')
    },
  },
  methods: {
    onChange(checked) {
      console.log(`a-switch to ${checked}`)
    },
    showDrawer(folder) {
      this.folder = folder
      this.folderShow = true
    },
    onClose() {
      this.folderShow = false
    },
  },
}
</script>
